












































import { Component, Mixins, Inject, Watch, Prop } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta';
import { mapActions } from 'vuex';
import { State } from 'vuex-class';
import { AxiosInstance, AxiosResponse } from 'axios';
import { Route } from 'vue-router';
import { format } from 'date-fns';
import {
  Breadcrumbs as BreadcrumbsLayout,
  Extra as ExtraLayout,
} from '@/components/layout';
import BlogPageLayout from '@/components/page/blog/article';
import ReviewsBlock from '@/components/parts/reviews';
import { List as RecommendedList } from '@/components/parts/catalog/list';
import { Context } from '@/types';
import mixin from '../mixins/mixin';
import isAuthorized from '@/mixins/isAuthorized';
import userData from '@/mixins/userData';
import reviewMixin from './../../review-mixin';
import createStoreModule, { INIT } from './store';
import { Id, Comments, Video } from './types';
import {
  ERROR_DEFAULT_TEXT,
  REVIEW_TITLE,
  REVIEW_BTN_TEXT,
  REVIEW_ERROR_TEXT,
  REVIEW_PLACEHOLDER,
  REVIEW_MODERATE_TEXT,
} from './const';

const STORE_MODULE_NAME = 'blog_article';
const actions = mapActions(STORE_MODULE_NAME, [INIT]);
const initStore = actions[INIT];

type NullOrNumber = null | number;

@Component({
  components: {
    BreadcrumbsLayout,
    BlogPageLayout,
    ReviewsBlock,
    ExtraLayout,
    RecommendedList,
  },

  metaInfo(): MetaInfo {
    const { seo_title, name, title, seo_description, seo_keywords } =
      this.$store.state[STORE_MODULE_NAME];
    return {
      title: seo_title || name || title || 'Блог',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: seo_description || 'Блог ЦОПП',
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content:
            seo_keywords ||
            'блог, цопп, профессиональная, подготовка, центр, опережающей',
        },
      ],
    };
  },

  storeName: STORE_MODULE_NAME,
  storeRegister: createStoreModule,
})
export default class PagesBlogArticle extends Mixins(
  mixin,
  isAuthorized,
  userData,
  reviewMixin
) {
  @Inject() $api: AxiosInstance;

  // Vuex
  @State(STORE_MODULE_NAME) state: any;

  // Props
  @Prop({ type: String, default: '' })
  code: string;

  @Prop({ type: Number, default: 2 })
  artLng: number;

  @Prop({ type: [Number, String], default: '' })
  id: Id;

  public targetId: NullOrNumber = null;
  readonly reviewTitle: string = REVIEW_TITLE;
  readonly compBtnText: string = REVIEW_BTN_TEXT;
  readonly errorValidationText: string = REVIEW_ERROR_TEXT;
  readonly placeholderText: string = REVIEW_PLACEHOLDER;
  readonly moderateText: string = REVIEW_MODERATE_TEXT;

  // Computed
  get crumbs() {
    const { breadcrumbs, state } = this;
    const { name, title } = state;
    const text = name || title;
    return [...breadcrumbs, { text }];
  }

  get articlesList() {
    const { artLng, state } = this;
    const { articles, id } = state;
    return articles.filter((obj: any) => obj.id != id).slice(0, artLng);
  }

  get middleThumb(): string {
    const { images } = this.state;
    return images ? images.middleThumb : '';
  }

  get videos(): Array<Video> {
    return Array.isArray(this.state.videos) ? this.state.videos : [];
  }

  get eventsRecommendedList() {
    return this.state.recommended;
  }

  get isCommentable(): boolean {
    if (!this.state.is_commentable) return false;
    return true;
  }

  get isModeratable(): boolean {
    if (!this.state.is_moderatable) return false;
    return true;
  }

  get isBlogReviewModule(): boolean {
    return this.$store.getters.hasApiModuleBlogReviews;
  }

  get reviewsBlock(): boolean {
    const { isBlogReviewModule, isCommentable } = this;
    return isCommentable && isBlogReviewModule;
  }

  // Watch
  @Watch('state.id', { immediate: true })
  onTargetId(value: string): void {
    if (this.isBlogReviewModule) this.targetId = parseInt(value, 10);
  }

  @Watch('$route', { immediate: true })
  onRouteChange(to: Route): void {
    if (this.reviewsBlock) {
      const { id } = to.params;
      this.loadReviews(parseInt(id, 10));
    }
  }

  // Methods
  asyncData({ store, route }: Context): Promise<any> {
    const context = { $store: store };
    const { id, code } = route.params;
    return initStore.call(context, { id, code });
  }

  submitReview(fields: Comments): void {
    const { targetId, isModeratable } = this;
    if (fields) {
      const data = {
        ...fields,
        target_id: targetId,
      };
      this.$api
        .post('article/publicblogreview', { data })
        .then<AxiosResponse<any>>(({ data: { data } }) => {
          if (!isModeratable) {
            this.addNewReview(data);
            this.closeModal = true;
          } else {
            this.reviewPopup = true;
          }
        })
        .catch((err: any) => {
          this.reviewError =
            err.response && err.response.data
              ? err.response.data.errors
              : ERROR_DEFAULT_TEXT;
        });
    }
  }

  loadReviews(target_id: NullOrNumber = this.targetId): void {
    this.$api
      .get<AxiosResponse<any>>('article/publicblogreview', {
        params: { target_id },
      })
      .then(({ data: { data } }) => {
        this.setLocalReviews(data);
      })
      .catch((err) => {
        this.localReviews = [];
      });
  }

  setLocalReviews(data: Array<any> = []): void {
    this.localReviews = data
      .filter(({ status }) => status === 'published')
      .map(({ fio, text, date }) => ({
        fio,
        text: text.replace(/<\/?[^>]+>/gi, ''),
        date: format(date, 'DD.MM.YYYY'),
      }));
  }

  addNewReview({ status, fio, text, date }: any): void {
    if (status === 'published') {
      this.localReviews.unshift({
        fio,
        text: text.replace(/<\/?[^>]+>/gi, ''),
        date: format(date, 'DD.MM.YYYY'),
      });
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/blog/article/component.vue